/**
 * <gift-card-picker> — selection logic for the gift card purchase section.
 *
 * Every selectable element carries data-variant-id (a gift card variant)
 * and data-price-formatted. Selecting one writes the variant id into the
 * hidden `name="id"` input of the product form and updates the displayed
 * value. Tabs ([data-gc-tab]) toggle the amount/workshop panels
 * ([data-gc-panel]). No dependencies, no network requests.
 */
class GiftCardPicker extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-gc-tab]');
      if (tab) this.#showPanel(tab);

      const tile = event.target.closest('button[data-variant-id]');
      if (tile) this.#select(tile);
    });

    this.addEventListener('change', (event) => {
      const radio = event.target.closest('input[type="radio"][data-variant-id]');
      if (radio && radio.checked) this.#select(radio);
    });
  }

  #showPanel(tab) {
    const name = tab.dataset.gcTab;
    this.querySelectorAll('[data-gc-tab]').forEach((t) => {
      t.classList.toggle('is-active', t === tab);
    });
    this.querySelectorAll('[data-gc-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.gcPanel !== name;
    });
  }

  #select(element) {
    const input = this.querySelector('input[name="id"]');
    if (input) input.value = element.dataset.variantId;

    const valueDisplay = this.querySelector('[data-gc-value]');
    if (valueDisplay) valueDisplay.textContent = element.dataset.priceFormatted;

    this.querySelectorAll('button[data-variant-id]').forEach((tile) => {
      const selected = tile === element;
      tile.classList.toggle('is-selected', selected);
      tile.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    this.querySelectorAll('input[type="radio"][data-variant-id]').forEach((radio) => {
      if (radio !== element) radio.checked = false;
    });

    this.querySelectorAll('[data-gc-card]').forEach((card) => {
      card.classList.toggle('is-selected', card.contains(element));
    });
  }
}

if (!customElements.get('gift-card-picker')) {
  customElements.define('gift-card-picker', GiftCardPicker);
}
